import { render, staticRenderFns } from "./PurchaseOrderDetailReport.vue?vue&type=template&id=20a85c2b&"
import script from "./PurchaseOrderDetailReport.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOrderDetailReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20a85c2b')) {
      api.createRecord('20a85c2b', component.options)
    } else {
      api.reload('20a85c2b', component.options)
    }
    module.hot.accept("./PurchaseOrderDetailReport.vue?vue&type=template&id=20a85c2b&", function () {
      api.rerender('20a85c2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchasing/reports/PurchaseOrderDetailReport.vue"
export default component.exports